import { css } from 'element-vir';
import { wrapTypeWithReadonly } from '../augments/type';
import { toniqColors } from './colors';
export const toniqShadows = wrapTypeWithReadonly()({
    popupShadow: css `
        filter: drop-shadow(0px 12px 8px ${toniqColors.dropShadow.backgroundColor});
    `,
});
